import { Grid, Typography, useTheme } from '@mui/material';
import { IconContainer } from './experience-card.styled';
import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';
import { formatDateRange } from '@lib/dateUtils';
import { useTranslation } from 'react-i18next';
import { DividerWithMarginStyled } from '@styled/divider-with-margin.styled';

interface ExperienceCardProps {
  title: string;
  startDate: string;
  endDate: string;
  establishment: string;
  description?: string;
  withDivider: boolean;
}

export const ExperienceCard = ({
  title,
  establishment,
  startDate,
  endDate,
  withDivider,
  description,
}: ExperienceCardProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <>
      <Grid container>
        <Grid item xs={2}>
          <IconContainer>
            <BriefcaseIcon
              height={IconSize.md}
              color={theme.palette.white.main}
            />
          </IconContainer>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="h4">{title}</Typography>
          <Typography variant="caption">{establishment}</Typography>
          <Typography variant="body2" mb={3}>
            {formatDateRange(startDate, endDate, t('YEARS'), t('MONTHS'))}
          </Typography>
          {description && (
            <Typography variant="caption">{description}</Typography>
          )}
        </Grid>
      </Grid>
      {withDivider && <DividerWithMarginStyled />}
    </>
  );
};
